import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { type CustomMutationParams, useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useChCreateLegalGuardianAttestationMutation as useChCreateLegalGuardianAttestationMutationType } from "@/modules/patients/detail/legal-guardian-attestation/ch/services/__generated__/useChCreateLegalGuardianAttestationMutation.graphql"

const mutation = graphql`
  mutation useChCreateLegalGuardianAttestationMutation($input: Ch_createAttestationGuardianInput!) {
    ch_createAttestationGuardian(input: $input) {
      ch_AttestationGuardian {
        id
        ...chLegalGuardianAttestationFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

const useChCreateLegalGuardianAttestationMutation = (params?: CustomMutationParams) => {
  const [commit, isFlight] = useMutationWithErrorDialog<useChCreateLegalGuardianAttestationMutationType>(
    mutation,
    params,
  )

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChCreateLegalGuardianAttestationMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChCreateLegalGuardianAttestationMutation }
